import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { Badge } from "../ui/badge";
import { projects } from "../../data/mock";

const categories = [
  { id: "all", label: "Todos" },
  { id: "embedded", label: "Embebidos" },
  { id: "it", label: "Informática" },
  { id: "audio", label: "Audio" },
];

export const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredProjects =
    activeCategory === "all"
      ? projects
      : projects.filter((p) => p.category === activeCategory);

  return (
    <section
      id="portafolio"
      className="relative py-28 lg:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#050510]" />
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(0,119,255,0.03)_0%,transparent_65%)]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-semibold text-[#0077FF] tracking-widest uppercase">
            Portafolio
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-white mt-4 leading-tight">
            Proyectos que{" "}
            <span className="text-white/30">demuestran resultados</span>
          </h2>
          <p className="text-white/35 mt-5 text-lg leading-relaxed">
            Una selección de trabajos que reflejan nuestra experiencia y
            compromiso con la calidad.
          </p>
        </div>

        {/* Category filter */}
        <div className="flex flex-wrap gap-3 mb-12">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 ${
                activeCategory === cat.id
                  ? "bg-[#0077FF] text-white shadow-lg shadow-[#0077FF]/20"
                  : "bg-white/[0.03] text-white/40 hover:text-white/70 border border-white/[0.06] hover:border-white/[0.1]"
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Projects grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project) => (
            <div
              key={project.id}
              className="group relative rounded-2xl overflow-hidden border border-white/[0.05] hover:border-[#0077FF]/20 transition-all duration-500 cursor-pointer bg-white/[0.01]"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050510] via-[#050510]/40 to-transparent" />

                {/* Hover overlay */}
                <div className="absolute inset-0 bg-[#0077FF]/0 group-hover:bg-[#0077FF]/[0.08] transition-colors duration-500 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-75 group-hover:scale-100">
                    <ExternalLink size={20} className="text-white" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-white mb-2">
                  {project.title}
                </h3>
                <p className="text-sm text-white/35 mb-4 leading-relaxed line-clamp-2">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag) => (
                    <Badge
                      key={tag}
                      variant="outline"
                      className="text-[11px] text-[#00b7ff] border-[#50bcfa]/15 bg-[#50bcfa]/[0.04] font-medium"
                    >
                      {tag}
                    </Badge>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
